import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const ItemTableForInvoiceRMPM = (props) => {
    return (
        <div className="itemList-table ">
            <div className="table-container overflow-y-flow h-[25.5vh] max-h-[25.5vh]"
            >
                <table className="itemList ">
                    <thead>
                        <tr>
                            <td className='w-[2%]'>Sr.</td>
                            <td className='w-[17%]'>Item Name</td>
                            <td className='w-[8%]'>Batch No</td>
                            <td className='w-[6%]'>Mfg. Date</td>
                            <td className='w-[6%]'>Exp. Date</td>
                            <td className='w-[6%]'>Qty.</td>
                            <td className='w-[6%]'>UOM.</td>
                            <td className='w-[6%]'>Rate</td>
                            <td className='w-[10%]'>Amount</td>
                            {/* <td className='w-[10%]'>Taxable Amt</td> */}
                            <td className='w-[8%]'>HSN Code</td>
                            <td className='w-[8%] !text-center'>Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.itemListing && props.itemListing.length > 0
                            ? props.itemListing.map((item, key) => (

                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.batchNo ? item.batchNo : '-'}</td>
                                    <td>{item.expDate ? moment(item.expDate).format('MM-yyyy') : '-'}</td>
                                    <td>{item.mfgDate ? moment(item.mfgDate).format('MM-yyyy') : '-'}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.uom}</td>
                                    <td>{Number(item.rate).toFixed(2)}</td>
                                    <td>{Number(item.amount).toFixed(2)}</td>
                                    {/* <td>{Number(item.taxableAmount).toFixed(2)}</td> */}
                                    <td>{item.hsnCodeName}</td>
                                    <td className='!text-center'>

                                        <button
                                            className="search-btn"
                                            onClick={() => props.editItemDetails(key)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {item.isFromDB ?
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemFromDBById(item)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                            :
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemById(key)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>

                                        }
                                    </td>
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
            <button
                disabled={props.isHideAddItem}
                className="add-btn mb-3 mt-2.5"
                onClick={() => props.openPopUpForAddingItem()}
            >
                Add Item
            </button>
        </div>
    );
};

export default ItemTableForInvoiceRMPM;